import { USER_STATUSES } from "utils/helpers/enums/shared.enum";

export class TeamMemberFilterDTO {
  page: number = 1;
  limit: number = 10;
  count: number = 1;
  size: number = 10;
  role: string = "";
  status: USER_STATUSES;
  nameOrEmail: string = "";
}
